import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { StatusAlertGitService } from './status-alert-git.service';

@Injectable({ providedIn: 'root' })
export class StatusAlertGitFactoryService extends AbstractGitFactoryService<StatusAlertGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: StatusAlertGitService,
    });
  }
}
